import React from 'react';
import { checkoutUrl, price } from '../data/salesCopy';
export function MobileCtaBar() {
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-ink-line bg-ink px-4 py-3 lg:hidden" data-id="element-73" data-mp="1oy5fhixirp8u">
      <div className="flex items-center gap-3" data-id="element-74" data-mp="1t00gsnfga2mm">
        <div className="min-w-0" data-id="element-75" data-mp="1sy5v36wcu6hh">
          <p className="text-[10px] uppercase tracking-[0.1em] text-cream/50" data-id="element-76" data-mp="1xz3axctw6oft">Hoy</p>
          <p className="font-display text-lg leading-none text-champagne-light" data-id="element-77" data-mp="1192r7s8dqy5d">{price.today}</p>
        </div>
        <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="flex flex-1 items-center justify-center rounded-2xl bg-champagne px-4 py-3.5 text-[13px] font-semibold uppercase tracking-[0.06em] text-ink transition-[transform,background-color] duration-150 ease-soft active:scale-[0.99] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-champagne" data-id="element-78" data-mp="15aehlzz2vnem">
          Quiero mi acceso
        </a>
      </div>
    </div>;
}